import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import { VANBANG_API } from '@app/utils/apiUrl';
import { Get, Put, Post } from '@app/utils/httpProvider';
import { messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import VanBangForm from './VanBangForm';

const toInputDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const VanBangEditComponent = () => {
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    // ĐÃ SỬA: Mở lại biến id
    const id = searchParams.get('id');

    const [isLoading, setIsLoading] = useState(false);

    // ĐÃ SỬA: Dùng đúng biến id thay vì itemId
    const { data: itemData, isLoading: isFetching } = useQuery(
        ['vanBangDetail', id],
        async () => {
            if (!id || id === 'undefined' || id === 'null') return null;
            const apiPath = VANBANG_API.GET_ITEM || VANBANG_API.GET_BY_ID;
            const response = await Get(apiPath, id);
            return response?.data || response;
        },
        {
            enabled: !!id && id !== 'undefined' && id !== 'null',
            cacheTime: 0,
            staleTime: 0,
            refetchOnMount: true,
            onError: (err) => {
                toast.error('Không thể lấy dữ liệu văn bằng!');
                history.push(URI_INTERNAL.VANBANG_PATH);
            }
        }
    );

    const editFunc = useMutation((value) => {
        const apiPath = VANBANG_API.UPDATE_ITEM || VANBANG_API.EDIT_ITEM || VANBANG_API.PUT_ITEM;
        if (typeof Put === 'function') {
            return Put(apiPath, id, value, false);
        } else {
            return Post(apiPath, id, value, false);
        }
    });

    const handleEdit = async (values) => {
        setIsLoading(true);
        try {
            const model = {
                id: id,
                accountId: values.accountId,
                tenVanBang: values.tenVanBang,
                loaiVanBang: values.loaiVanBang || null,
                chuyenNganh: values.chuyenNganh,
                coSoCapBang: values.coSoCapBang,
                quocGiaCap: values.quocGiaCap,
                soHieuVanBang: values.soHieuVanBang,
                ngayCap: values.ngayCap ? new Date(values.ngayCap).toISOString() : null,
                xepLoai: values.xepLoai || null,
                isHopPhapHoa: values.isHopPhapHoa,
                soQDCongNhan: values.isHopPhapHoa ? (values.soQDCongNhan || null) : null,
                fileMinhChungId: values.fileMinhChungId || null,
                ghiChu: values.ghiChu || null,
                // Khi sửa thông tin, đẩy trạng thái về Chờ duyệt (1) để cán bộ duyệt lại
                trangThai: 1,
                // Nếu là văn bằng trong nước thì mặc định quốc gia là Việt Nam
                quocGiaCap: values.loaiVanBang === 'VanBangTrongNuoc' ? 'Việt Nam' : values.quocGiaCap
            };

            editFunc.mutate(model, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastUpdateError || 'Cập nhật thất bại');
                    } else {
                        toast.success(messageToast.messageToastUpdateSuccess || 'Cập nhật văn bằng thành công!');
                        history.push(URI_INTERNAL.VANBANG_PATH);
                    }
                },
                onError: (err) => {
                    toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
                },
                onSettled: () => {
                    setIsLoading(false);
                }
            });
        } catch (error) {
            setIsLoading(false);
            console.error('Lỗi cập nhật Văn bằng:', error);
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại!');
        }
    };

    if (isFetching) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ms-3 text-muted">Đang tải dữ liệu văn bằng...</span>
            </div>
        );
    }

    if (!itemData && !isFetching) {
        return <div className="text-center mt-5 text-danger fw-500">Không tìm thấy dữ liệu văn bằng!</div>;
    }

    const initialValues = {
        accountId: itemData?.accountId || itemData?.AccountId || '',
        tenVanBang: itemData?.tenVanBang || itemData?.TenVanBang || '',
        loaiVanBang: itemData?.loaiVanBang || itemData?.LoaiVanBang || '',
        chuyenNganh: itemData?.chuyenNganh || itemData?.ChuyenNganh || '',
        coSoCapBang: itemData?.coSoCapBang || itemData?.CoSoCapBang || '',
        quocGiaCap: itemData?.quocGiaCap || itemData?.QuocGiaCap || '',
        soHieuVanBang: itemData?.soHieuVanBang || itemData?.SoHieuVanBang || '',
        ngayCap: toInputDate(itemData?.ngayCap || itemData?.NgayCap),
        xepLoai: itemData?.xepLoai || itemData?.XepLoai || '',
        isHopPhapHoa: itemData?.isHopPhapHoa || itemData?.IsHopPhapHoa || false,
        soQDCongNhan: itemData?.soQDCongNhan || itemData?.SoQDCongNhan || '',
        fileMinhChungId: itemData?.fileMinhChungId || itemData?.FileMinhChungId || '',
        // Nếu Backend không trả về Path/Name, nó sẽ nhận chuỗi rỗng
        fileMinhChungPath: itemData?.fileMinhChungPath || itemData?.FileMinhChungPath || '',
        fileMinhChungName: itemData?.fileMinhChungName || itemData?.FileMinhChungName || '',
        ghiChu: itemData?.ghiChu || itemData?.GhiChu || '',
        trangThai: itemData?.trangThai || itemData?.TrangThai || ''
    };

    return (
        <VanBangForm
            title="Cập nhật Văn bằng"
            submitText="Lưu thay đổi"
            initialValues={initialValues}
            onSubmit={handleEdit}
            onCancel={() => history.push(URI_INTERNAL.VANBANG_PATH)}
            isSubmitting={isLoading}
        />
    );
};

class VanBangEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: '' };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, errorMessage: error.toString() };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Lỗi Render tại trang Edit:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-4 m-4" style={{ border: '2px dashed red', borderRadius: '8px', backgroundColor: '#fff5f5' }}>
                    <h4 className="text-danger"><i className="fas fa-exclamation-triangle me-2"></i> Lỗi Code (Crash Component)</h4>
                    <p className="text-dark fw-500">Ứng dụng đã bắt được lỗi nên không bị màn hình trắng. Vui lòng xem thông báo lỗi dưới đây:</p>
                    <pre className="p-3 bg-dark text-warning rounded" style={{ whiteSpace: 'pre-wrap' }}>{this.state.errorMessage}</pre>
                </div>
            );
        }
        return <VanBangEditComponent {...this.props} />;
    }
}

export default VanBangEdit;